import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ErrorDialogComponent } from '../components/error-dialog/error-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private readonly injector: Injector) {}
  dialogRef: any;
  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk \d+ failed/;
    if (chunkFailedMessage.test(error.message)) {
      this.openNewVersionBanner();
    }
  }

  openNewVersionBanner(): void {
    if (!this.dialogRef) {
      this.dialogRef = this.injector.get(DialogService);
      this.dialogRef.open(ErrorDialogComponent, {
        header: 'New Version Available',
        width: '300px',
        closable: false,
      });
    }
  }
}
